import { render, staticRenderFns } from "./topic-content-header.vue?vue&type=template&id=49ef9a98&scoped=true"
import script from "./topic-content-header.vue?vue&type=script&lang=js"
export * from "./topic-content-header.vue?vue&type=script&lang=js"
import style0 from "./topic-content-header.vue?vue&type=style&index=0&id=49ef9a98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49ef9a98",
  null
  
)

export default component.exports